import BaseApi from "./baseApi";

export default class LogApi extends BaseApi {
    async postLog(log: Log): Promise<Order> {
        const url = "/api/log/log";
        return await this.fetchPost(url, log);
    }
}
